function materialConfig($mdThemingProvider, $mdAriaProvider) {
  "ngInject";

  $mdAriaProvider.disableWarnings();

  const customBlueGrey = $mdThemingProvider.extendPalette("blue-grey", {
    50: "#E1F5FE",
    100: "#B3E5FC",
    200: "#81D4FA",
    300: "#4FC3F7",
    400: "#29B6F6",
    500: "#03A9F4",
    600: "#039BE5",
    700: "#0288D1",
    800: "#0277BD",
    900: "#01579B",
    A100: "#80D8FF",
    A200: "#40C4FF",
    A400: "#00B0FF",
    A700: "#0091EA",
  });

  $mdThemingProvider.definePalette("customBlueGrey", customBlueGrey);

  $mdThemingProvider.theme("accent").primaryPalette("customBlueGrey");
}

export default materialConfig;



// WEBPACK FOOTER //
// ./src/material/material.js